let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7aZr3")).then(() => parcelRequire('hC7hu'));